import React from "react";
import styles from "./Input.module.scss";
import { Controller } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import { InputAdornment, TextField } from "@mui/material";
import { combineClasses } from "@/lib/utils";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

const Input: React.FC<InputControlProps> = (props) => {
  const {
    control,
    register,
    validations,
    name,
    placeholder,
    type,
    startIcon,
    endIcon,
    error,
    className,
    ...rest
  } = props;

  const { min, max, ...textfieldProps } = rest;

  const renderInput = (field = {}) => (
    <TextField
      {...field}
      {...rest}
      id={name}
      label=""
      variant="outlined"
      type={type || "text"}
      className={combineClasses(
        styles.inputRoot,
        error && styles.error,
        className
      )}
      placeholder={placeholder}
      slotProps={{
        input: {
          startAdornment: startIcon ? (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          ) : null,
          endAdornment: endIcon ? (
            <InputAdornment position="end">{endIcon}</InputAdornment>
          ) : null,
        },
        htmlInput: {
          min,
          max,
          step: "any",
          autoComplete: "off",
          className: combineClasses(
            styles.inputField,
            Boolean(startIcon) && styles.startIcon,
            props?.multiline && styles.textarea
          ),
        },
      }}
    />
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderInput(field)}
      />
    );
  } else {
    const field = register?.(name, validations);
    return renderInput(field);
  }
};

const InputWithLabelAndError = withLabelAndError(
  Input as WithLabelAndErrorComponent
);

export default InputWithLabelAndError;
export { Input };
